import { message } from 'antd';

import { getErrorMsg } from './getErrorMsg';

export const getErrorHandler = (msg) => (error) => {
  const errorMsg = getErrorMsg(error);

  message.error(`${msg ? `${msg}. ` : ``}${errorMsg ? ` ${errorMsg}.` : ''}`);
};
